import { useEffect } from 'react';
import PianoWrapper from '../../lib/Piano/PianoWrapper';

/**
 * Component responsible for setting custom variables and reloading the Piano gate.
 * Initializes specific variables for the PianoWrapper and ensures that
 * the Piano SDK gate is reloaded either immediately (if the SDK is ready) or queued
 * to reload once the SDK becomes ready.
 * @returns {null} This component does not render any visible UI.
 */
const Piano = () => {
  useEffect(() => {
    // Set Piano custom variables
    PianoWrapper.setVariable('updatedEvents', 'true');

    // Execute immediately if SDK is ready, otherwise queue it
    if (window.tp?.experience?.execute) {
      PianoWrapper.reloadGate();
    } else {
      window.tp = window.tp || [];
      window.tp.push(() => {
        PianoWrapper.reloadGate();
      });
    }
  }, []); // Run once on mount

  return null;
};

// eslint-disable-next-line import/no-default-export
export default Piano;
